import { Tooltip } from '@/fsd/shared/ui/tooltip';
import style from './AllBarcodes.module.scss';

const AllBarcodes = ({ barcodes }) => {
  if (!barcodes) return;

  return (
    <>
      <span className={style.productSkuDesc}>ШК:</span>{' '}
      {barcodes?.length <= 1 ? (
        barcodes?.[0]
      ) : (
        <Tooltip content={`${barcodes?.join('\n')}`}>
          <span>
            {barcodes?.[0]}{' '}
            <span className={style.productSkuAddNumber}>
              +{barcodes?.length - 1}
            </span>
          </span>
        </Tooltip>
      )}
    </>
  );
};

export default AllBarcodes;
